<template>
  <div v-if="isDataLoading == true" class="row">
       <div class="col">
           <vue-loaders name="ball-beat"></vue-loaders>
       </div>
  </div>
  <div v-else>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-7 lbl text-vertical-center">
          <label>Montant :</label>
        </div>
        <div class="col-5">
          <InputNumber
              id="montant"
              mode="decimal"
              :minFractionDigits="2"
              v-model="narrationLocal.montant"/>
        </div>
      </div>
      <div class="row">
        <div class="col-7 lbl"><label>Rapporté Par :</label></div>
        <div class="col-5 txt">
          <p v-if="!narrationLocal.rapporteParDescription"> ... </p>
          <p v-else> {{ narrationLocal.rapporteParDescription }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-7 lbl"><label>Temps consacré (En minutes) :</label></div>
        <div class="col-5">
          <InputText id="temps" type="number" v-model="narrationLocal.temps" :useGrouping="false"/>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 lbl"><label>Confidentialité :</label></div>
        <div class="col-7">
          <Dropdown id="confidentialite" v-model="narrationLocal.confidentialite" :options="confidentialiteLibelles"
                    optionValue="valeur" optionLabel="texte" scrollHeight="580px" :showClear="true"/>
        </div>
      </div>
      <div class="row" v-if="showGabarit">
        <div class="col-5 lbl"><label>Numéro séquentiel :</label></div>
        <div class="col-7">
          <Dropdown id="numeroSequence" v-model="narrationLocal.numeroSequence" :options="numeroSequenceLibelles"
                    optionValue="value" optionLabel="content" scrollHeight="580px" :showClear="true"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-8"/>
        <div class="col lbl" v-if="showGabarit"><label>Gabarit standard :</label></div>
        <div class="col lbl" v-if="showGabarit"><label>Gabarit uniformisé : </label></div>
      </div>
      <div class="row" v-if="showGabarit">
        <div class="col-2 offset-8">
          <Dropdown id="gabarit" v-model="narrationLocal.gabarit" :options="gabaritLibelles"
                    optionValue="valeur" optionLabel="texte" class="gab"
                    scrollHeight="580px" :showClear="true"/>
        </div>
        <div class="col-2">
          <Dropdown id="selectedGabaritUnif" v-model="selectedGabaritUnif" :options="listeGabaritUnif"
                    optionValue="value" optionLabel="content" class="gab"
                    scrollHeight="580px" :showClear="true"/>
        </div>
      </div>
    </div>
  </div>
  
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col left">
          <div class="col-12 file-toolbar-menu" v-if="showGabarit">
            <vue-file-toolbar-menu :content="menu_bar" class="backg"/>
          </div>
          <div class="scrollable">
            <vue-document-editor       
            id="editor"
            ref="editor"
            :key="componentKey"
            @paste="handlePaste"
            v-model:content="content"
            :page_format_mm="dimensions"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
<!--  <div class="row">
    <div class="col">
      <FileUpload name="fichiers" accept=".docx" chooseLabel="Sélectionner" uploadLabel="Importer"
                  :fileLimit="1" invalidFileLimitMessage="Le nombre de fichiers dépasse la limite de {0}"
                  invalidFileTypeMessage="Ce n'est pas un fichier docx"
                  :customUpload="true" @uploader="importerFichierWord" ref="monUpload">
        <template #empty>
          <p>Déposer le fichier ici.</p>
        </template>
      </FileUpload>
    </div>
  </div>-->
  <div class="row">
    <div class="col">
      <Information :approuveLe="approuveLe" :creerLe="creerLe" :modifieLe="modifieLe" :narrationLocal="narrationLocal" :numeroCardex="numeroCardex"/>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";
import Information from '../Commun/Information.vue';
import VueDocumentEditor from 'vue-document-editor';
import VueFileToolbarMenu from 'vue-file-toolbar-menu';

export default {
  name: "ModifierChamps",
  emits: ["fermer"],
  props: ['isModifier', 'isSauvegardeReussie'],
  components: {Information, VueDocumentEditor, VueFileToolbarMenu},
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.isDataLoading = true;
    if (this.isModifier) {
      this.getNarration();
    } else {
      this.$store.commit("narration/NARRATION_STORE_STATE_RESET");
      this.getNarrationTemporaire();
    }
  },
  computed: {
    ...mapGetters({
      narration: 'narration/narration',
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      dossier : 'dossier/dossier',
    }),
    menu_bar() {
      return [
        {icon: "format_bold", title: "Gras", click: () => document.execCommand("bold")},
        {icon: "format_italic", title: "Italique", click: () => document.execCommand("italic")},
        {icon: "format_underline", title: "Soulignement", click: () => document.execCommand("underline")},
        {is: "separator"},
        // Ne fonctionne pas bien.
        // {icon: "format_indent_increase", title: "Indentation", click: () => document.execCommand("indent")},
        // {icon: "format_indent_decrease", title: "Retrait", click: () => document.execCommand("outdent")},
        {icon: "format_list_numbered", title: "Numbered list", click: () => document.execCommand("insertOrderedList")},
        {
          icon: "format_list_bulleted",
          title: "Bulleted list",
          click: () => document.execCommand("insertUnorderedList")
        },
        { is: "separator" },
        {
          html: '<div class="ellipsis" style="width: 80px; font-size: 95%;">'+this.font+'</div>',
          title: "Font",
          chevron: true,
          menu: this.font_menu,
          menu_height: 200
        },
        {is: "separator"},
        {
          text: "Taille",
          menu: [
            {html: "<b>H1</b>", title: "Header 1", click: () => document.execCommand('formatBlock', false, '<h1>')},
            {html: "<b>H2</b>", title: "Header 2", click: () => document.execCommand('formatBlock', false, '<h2>')},
            {html: "<b>H3</b>", title: "Header 3", click: () => document.execCommand('formatBlock', false, '<h3>')},
          ]
        },
        {is: "separator"},
        {icon: "format_align_left", title: "Align left", click: () => document.execCommand("justifyLeft")},
        {icon: "format_align_center", title: "Align center", click: () => document.execCommand("justifyCenter")},
        {icon: "format_align_right", title: "Align right", click: () => document.execCommand("justifyRight")},
        {icon: "format_align_justify", title: "Justify content", click: () => document.execCommand("justifyFull")},
        { title: "Undo", icon: "undo", disabled: !this.can_undo, hotkey: "ctrl+z", click: () => this.undo() },
        { title: "Redo", icon: "redo", disabled: !this.can_redo, hotkey: "ctrl+y", click: () => this.redo() },
      ]
    },
    font_menu () {
      return this.font_list.map(font => {
        return {
          html: '<span class="ellipsis" style="font-family:'+font+'">'+font+'</span>',
          icon: (this.font == font) ? 'check' : false,
          active: (this.font == font),
          height: 20,
          click: () => {
            document.execCommand("fontName", false, font);
            this.font = font;
          }
        };
      });
    },
    font_list: () => ["Arial", "Courier New", "Garamond", "Georgia", "Impact", "Times New Roman", "Verdana"],
    //font_list: () => ["Arial", "Avenir", "Courier New", "Garamond", "Georgia", "Impact", "Helvetica", "Palatino", "Roboto", "Times New Roman", "Verdana"],
    is_touch_device: () => ("ontouchstart" in window) || (window.navigator.msMaxTouchPoints > 0),
    can_undo () { return this.undo_count > 1; },
    can_redo () { return this.content_history.length - this.undo_count - 1 > 0; }

  },
  created () {

    const manage_undo_redo = (e) => {
      switch(e && e.inputType){
        case "historyUndo": e.preventDefault(); e.stopPropagation(); this.undo(); break;
        case "historyRedo": e.preventDefault(); e.stopPropagation(); this.redo(); break;
      }
    }
    window.addEventListener("beforeinput", manage_undo_redo);
    window.addEventListener("input", manage_undo_redo); // in case of beforeinput event is not implemented (Firefox)
  },
  data() {
    return {   
      undo_count: -1,
      content_history: [],
      dimensions: [200,800],
      componentKey: 0,
      pixelToMMConverter: 0.2645,
      isDataLoading: false,
      font: "Arial",
      //font: "Avenir",
      confidentialiteLibelles: null,
      gabaritLibelles: null,
      modifiable: false,
      narrationLocal: {},
      numeroCardex: null,
      approuveLe: null,
      creerLe: null,
      modifieLe: null,
      showGabarit: false,
      contentGab: null,
      content: [],
      selectedGabaritUnif: null,
      isGabarit: false,
      numeroSequenceLibelles: [
        {value: 'Page titre 1', content: 'Page titre 1'},
        {value: 'Identification 1', content: 'Identification 1'},
        {value: 'Table des matières 1', content: 'Table des matières 1'},
        {value: 'Introduction 1', content: 'Introduction 1'},
        {value: 'Enquête 1', content: 'Enquête 1'},
        {value: 'Enquête 1.1', content: 'Enquête 1.1'},
        {value: 'Enquête 1.2', content: 'Enquête 1.2'},
        {value: 'Enquête 2', content: 'Enquête 2'},
        {value: 'Enquête 2.1', content: 'Enquête 2.1'},
        {value: 'Enquête 2.2', content: 'Enquête 2.2'},
        {value: 'Enquête 3', content: 'Enquête 3'},
        {value: 'Enquête 3.1', content: 'Enquête 3.1'},
        {value: 'Enquête 3.2', content: 'Enquête 3.2'},
        {value: 'Enquête 4', content: 'Enquête 4'},
        {value: 'Enquête 4.1', content: 'Enquête 4.1'},
        {value: 'Enquête 4.2', content: 'Enquête 4.2'},
        {value: 'Enquête 5', content: 'Enquête 5'},
        {value: 'Enquête 5.1', content: 'Enquête 5.1'},
        {value: 'Enquête 5.2', content: 'Enquête 5.2'},
        {value: 'Enquête 6', content: 'Enquête 6'},
        {value: 'Constat 1', content: 'Constat 1'},
        {value: 'Conclusion 1', content: 'Conclusion 1'},
        {value: 'Recommandations 1', content: 'Recommandations 1'},
        {value: 'Autres 1', content: 'Autres 1'},
        {value: 'Autres 2', content: 'Autres 2'},
        {value: 'Autres 3', content: 'Autres 3'},
      ],
      listeGabaritUnif: [
        {value: 'pagetitre.html', content: 'Page titre'},
        {value: 'identification_CHA.html', content: 'Identification Charlevoix'},
        {value: 'identification_HUL.html', content: 'Identification Lac-Leamy'},
        {value: 'identification_LQC.html', content: 'Identification Loto-Québec'},
        {value: 'identification_MTL.html', content: 'Identification Montréal'},
        {value: 'identification_MTB.html', content: 'Identification Mont-Tremblant'},
        {value: 'identification_SEJ.html', content: 'Identification Établissements de jeux'},
        {value: 'identification_SSJQ.html', content: 'Identification Salons de jeux'},
        {value: 'tablematieres.html', content: 'Table des matières'},
        {value: 'introduction.html', content: 'Introduction'},
        {value: 'enquete.html', content: 'Enquête'},
        {value: 'constat.html', content: 'Constat'},
        {value: 'conclusion.html', content: 'Conclusion'},
        {value: 'recommandation.html', content: 'Recommandations'},
      ],
    };
  },
  methods: {
    handlePaste(event) {
      event.preventDefault();
      
      let clipboardData = (event.clipboardData || window.clipboardData);

      const pastedHTML = clipboardData.getData('text/html');
      
      //si le presse-papier contient du HTML
      if(pastedHTML) {
        event.preventDefault();
        const tempDiv = document.createElement('span');
        tempDiv.innerHTML = pastedHTML;
        
        const selection = window.getSelection();
        if(selection) {
          const range = selection.getRangeAt(0);
          range.deleteContents();
          range.insertNode(tempDiv);
          let html = this.$el.querySelector("#editor");
          let innerHtml = html?.querySelector("div.content > div").innerHTML;
          this.setHeightAndWidth();
          this.content[0] = innerHtml;
        }
      }else {
        const pastedText = clipboardData.getData('text');
        event.preventDefault();
        const tempDiv = document.createElement('span');
        tempDiv.innerHTML = pastedText;
        
        const selection = window.getSelection();
        if(selection) {
          const range = selection.getRangeAt(0);
          range.deleteContents();
          range.insertNode(tempDiv);
          let html = this.$el.querySelector("#editor");
          let innerHtml = html?.querySelector("div.content > div").innerHTML;
          this.setHeightAndWidth();
          this.content[0] = innerHtml;
        }
      }
    },
    setHeightAndWidth(){
      const editorDiv = this.$el?.querySelector("#editor");
      const contentDiv = editorDiv?.querySelector("div.content > div");
      if(contentDiv != undefined && contentDiv.children != undefined){
        let totalHeight = 0;
        for(let i = 0; i < contentDiv.children.length; i++){
          const child = contentDiv.children[i];
          const height = child.offsetHeight;
          totalHeight += height * this.pixelToMMConverter;
        }
        this.isGabarit = false;
        if(totalHeight > this.dimensions[1] - 300){
          this.dimensions[1] = totalHeight + 350;
          this.forceRerender();
            this.$nextTick(() => {
              this.$el?.querySelector("#editor")?.querySelector('div.content')?.querySelector('div').click();
            })
        }
      }
    },
    setHeightAndWidthUserInput(){
      const editorDiv = this.$el?.querySelector("#editor");
      const contentDiv = editorDiv?.querySelector("div.content > div");
      if(contentDiv != undefined && contentDiv.children != undefined){
        let totalHeight = 0;
        for(let i = 0; i < contentDiv.children.length; i++){
          const child = contentDiv.children[i];
          const height = child.offsetHeight;
          totalHeight += height * this.pixelToMMConverter;
        }
        if(totalHeight > this.dimensions[1] - 50){
          this.dimensions[1] = totalHeight + 350;
          this.forceRerender();
          this.$nextTick(() => {
            this.$el?.querySelector("#editor")?.querySelector('div.content')?.querySelector('div').click();
          })
        }
      }
    },
    setHeightAndWidthInit(content){
      this.$nextTick(() => {
        const editorDiv = this.$el?.querySelector("#editor");
        const tempDiv = editorDiv?.querySelector("div.content > div");
        tempDiv.innerHTML = content;
        if(tempDiv != undefined && tempDiv.children != undefined){
          let totalHeight = 0;
          for(let i = 0; i < tempDiv.children.length; i++){
            const child = tempDiv.children[i];
            const height = child.clientHeight;
            totalHeight += height * this.pixelToMMConverter;
          }
          if(totalHeight > this.dimensions[1] - 30){
            this.dimensions[1] = totalHeight + 230;
            this.forceRerender();
          }
        }        
      })
    },
    forceRerender() {
      this.componentKey += 1
    },
    undo () { if(this.can_undo){ this._mute_next_content_watcher = true; this.content[0] = this.content_history[--this.undo_count]; } },
    redo () { if(this.can_redo){ this._mute_next_content_watcher = true; this.content[0] = this.content_history[++this.undo_count]; } },
    resetContentHistory () { this.content_history = []; this.undo_count = -1; },

    getNarrationLocal() {    
      this.narrationLocal.temporaire = false;
      this.narrationLocal.texteHTML = this.$el.querySelector("#editor").querySelector('div.content').querySelector('div').innerHTML;
      return this.narrationLocal;
    },
    getNarrationLocalTemporaire() {
        this.narrationLocal.texteHTML = this.$el.querySelector("#editor").querySelector('div.content').querySelector('div').innerHTML;
        this.narrationLocal.temporaire = true;
        return this.narrationLocal;
    },
    getNarrationStore() {
      return this.narration;
    },
    updateNarrationLocal() {
      this.narrationLocal = {...this.narration};
    },
    assignerNarration(res) {
      if (res.data.entite != null && !res.data.entite.temporaire) {
        this.narrationLocal = {...res.data.entite};
      }
      if (!this.isModifier) {
        this.creerLe = this.$commun.formatDateHeure(new Date());
        if(res.data.entite.confidentialite == null){
          this.narrationLocal.confidentialite = this.profil.confidentialite;
        }
        this.forcerConfAUn(this.$route.params.genre.trim(), this.dossier.nature);
        if (this.$route.params.genre !== undefined && this.$route.params.genre.trim() !== 'VE') {
          this.showGabarit = true;
        }
      } else {
        this.showGabarit = this.narrationLocal.genreReference.trim() !== 'VE';
        this.approuveLe = this.$commun.formatDateHeure(this.narrationLocal.approuveLe);
        this.creerLe = this.$commun.formatDateHeure(this.narrationLocal.creerLe);
        this.modifieLe = this.$commun.formatDateHeure(this.narrationLocal.modifieLe);
        this.content[0] = this.narrationLocal.texteHTML;
        this.setHeightAndWidthInit(this.narrationLocal.texteHTML);
      }
      this.confidentialiteLibelles = res.data.entiteDecision.confidentialiteNarration.libelles;
      this.gabaritLibelles = res.data.entiteDecision.gabarit.libelles;
      this.numeroCardex = this.dossier.numeroCardexAfficher;
    },
    assignerNarrationTemporaire(narrationTemporaire){
        this.content[0] = narrationTemporaire.texteHTML;
        this.setHeightAndWidthInit(narrationTemporaire.texteHTML);
    },
    getNarration() {
      this.$store
          .dispatch("narration/consulterAction", {
            cle: this.$route.params.cle,
            site: this.$route.params.site
          })
          .then((res) => {
            this.$store.commit('narration/UPDATE_NARRATION', res.data.entite);
            this.assignerNarration(res);
            this.isDataLoading = false;
          });
    },
    getNarrationTemporaire() {
      this.$store
          .dispatch("narration/consulterTemporaireAction", {
            cle: this.$route.params.cle,
            site: this.$route.params.site,
            genre: this.$route.params.genre
          })
          .then((res) => {
            this.assignerNarration(res);
            this.isDataLoading = false;
          });
    },
/*    importerFichierWord(event) {
      let file = event.files[0];
      let fileName = file['name'];
      console.log('Le bouton Importer fichier Word actionné : ' + fileName);
      this.$store
          .dispatch("narration/importerFichierWordAction", {
            fichierWord: file
          })
          .then((res) => {
            //this.narrationLocal.texteHTML = this.narrationLocal.texteHTML + ' ' + res.data;
            this.content[0] = this.content[0] + ' ' + res.data;
          });
      this.$refs.monUpload.value = null;
    },*/
    setNumeroSequence(gabarit) {
      //Assignation du numéro de séquence selon le gabarit choisi
      if (gabarit == "pagetitre.html") {
        this.narrationLocal.numeroSequence = "Page titre 1";
      }
      if (gabarit == "identification_MTB.html" || gabarit == "identification_CHA.html" || gabarit == "identification_HUL.html" || gabarit == "identification_LQC.html" || gabarit == "identification_MTL.html" || gabarit == "identification_SEJ.html" || gabarit == "identification_SSJQ.html") {
        this.narrationLocal.numeroSequence = "Identification 1";
      }
      if (gabarit == "tablematieres.html") {
        this.narrationLocal.numeroSequence = "Table des matières 1";
      }
      if (gabarit == "introduction.html") {
        this.narrationLocal.numeroSequence = "Introduction 1";
      }
      if (gabarit == "enquete.html") {
        this.narrationLocal.numeroSequence = "Enquête 1";
      }
      if (gabarit == "constat.html") {
        this.narrationLocal.numeroSequence = "Constat 1";
      }
      if (gabarit == "conclusion.html") {
        this.narrationLocal.numeroSequence = "Conclusion 1";
      }
      if (gabarit == "recommandation.html") {
        this.narrationLocal.numeroSequence = "Recommandations 1";
      }
    },
    forcerConfAUn(genre, nature) {
      // Dans le cas d'un avis de guet, la confidentialité est forcé à 'un'. Pour permettre à tout les utilisateurs
      // de consulter la narration. Sinon, on ne change pas la valeur déjà attribuée.
      // applicable aux sites Loterie et Casino d'État
      if (genre === 'DO' && (nature === 78 || nature === 27118 || nature === 417 || nature === 27074)) {
        this.narrationLocal.confidentialite = 366;
      }
    },
  },
  watch: {
    'narrationLocal.gabarit': function (gabarit) {
      if (gabarit && gabarit != this.narration.gabarit) {
        this.$store.dispatch('narration/obtenirGabaritAction', {
          gabarit: gabarit, gabaritUnif: null, typeGabarit: true
        }).then((res) => {
          this.contentGab = res.data.entite;
          this.content[0] = this.content[0] + this.contentGab;
        });
      }
    },
    'selectedGabaritUnif': function (gabaritUnif) {
      if (gabaritUnif) {
        this.$store.dispatch('narration/obtenirGabaritAction', {
          gabarit: 0, gabaritUnif: gabaritUnif, typeGabarit: false
        }).then((res) => {
          this.isGabarit = true;
          this.contentGab = res.data.entite;
          this.content[0] = this.content[0] + this.contentGab;
          this.setNumeroSequence(gabaritUnif);
        });
      }
    },
    'content.0': {
      immediate: true,
      // Fill undo / redo history stack on user input
      handler (new_content) {
        if(this.isGabarit) {
          this.setHeightAndWidth();
        } else {
          this.setHeightAndWidthUserInput();
        }
        if(!this._mute_next_content_watcher) { // only update the stack when content is changed by user input, not undo/redo commands
          this.content_history[++this.undo_count] = new_content;
          this.content_history.length = this.undo_count + 1; // remove all redo items
        }
        this._mute_next_content_watcher = false;
      }
    },
  }
};
</script>